module.exports = "https://static.wmbcdn.com/uniweb/images/637f15a0d50f023904306892ea4c3b80.svg";